<template>
  <el-dialog class="bug_model_dialog" top="5vh" center :title="newTitle" :append-to-body="true" width="80%" :before-close="handleClose"
             :visible.sync="dialogVisible" :close-on-click-modal="false">
    <el-form v-loading="loading.dialog" size="mini" ref="form" :rules="rules" :model="form">
      <Share v-if="isUpdata" :shareInfo="{ pid: form.db_id, type: 'demand' }" />
      <el-form-item  label="标题" prop="title" :label-width="formLabelWidth">
        <el-input v-model="form.title" autocomplete="off" :disabled="isProjectDisabled">
        </el-input>
      </el-form-item>
      <el-form-item label="内容"  prop="context" :label-width="formLabelWidth" >
        <Editor v-if="!loading.dialog"  :content="form.context" @contentData="changeContent"
                :dialogVisibleModelType="form.id ? 'update' : 'create'" />
      </el-form-item>
      <div style="display:flex;">
        <el-form-item label="环境" prop="type" :label-width="formLabelWidth">
          <el-select size="mini"  @change="changeType" :disabled="isProjectDisabled"  v-model="form.type"
                     collapse-tags filterable placeholder="请选择任务类型">
            <el-option v-for="(item, index) in BUGTYPE" :key="index" :label="item"
                       :value="index" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="优先级" prop="priority" :label-width="formLabelWidth">
          <el-select size="mini" :disabled="isProjectDisabled" v-model="form.priority" filterable placeholder="请选择优先级">
            <el-option v-for="(key, value) in allSelect.TEXTPRIORITY" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="关联测试任务" prop="testTaskId" :label-width="formLabelWidth">
          <el-select size="mini"  @change="changeTestTask" @focus="focusHandle" :disabled="isProjectDisabled" v-model="form.testTaskId"
                     collapse-tags filterable placeholder="请选择任务">
            <el-option v-for="(key, value) in reltestList" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="关联开发任务" prop="devTaskId" :label-width="formLabelWidth">
          <el-select size="mini"  @change="changeTask" :disabled="isProjectDisabled" v-model="form.devTaskId"
                     collapse-tags filterable placeholder="请选择任务">
            <el-option v-for="(key, value) in tasks" :key="key" :label="key" :value="value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="负责人" prop="ownerId"  :label-width="formLabelWidth">
          <el-select :style="iptStyle"   filterable collapse-tags  size="mini"  :disabled="isProjectDisabled" v-model="form.ownerId"   placeholder="请选择负责人">
            <el-option v-for="(key, value) in allUserList.ALLUSERTYPE1" :key="key" :label="key" :value="value" />

          </el-select>
        </el-form-item>
        <el-form-item label="系统" prop="module" :label-width="formLabelWidth">
          <el-input :value="allSelect.TEXTMODULES[form.module]" :disabled="true" autocomplete="off">
          </el-input>
        </el-form-item>
      </div>
      <div style="display: flex;">
        <el-form-item label="计划完成日期" prop="planFinishDate" :label-width="formLabelWidth">
          <el-date-picker :disabled="isProjectDisabled" value-format="yyyy-MM-dd"
                          v-model="form.planFinishDate" type="date" placeholder="请选择日期" />
        </el-form-item>
        <el-form-item  label="创建人" prop="creatorId" :label-width="formLabelWidth">
          <el-select :style="iptStyle"  @change="changeCreatorId"   filterable collapse-tags  size="mini"  :disabled="isProjectDisabledEdit" v-model="form.creatorId"   placeholder="请选择创建人">
            <el-option v-for="(key, value) in allUserList.DEVUSER" :key="key" :label="key" :value="value" />
          </el-select>
        </el-form-item>
      </div>
      <el-form-item v-if="form.status === 'completed'" label="处理内容"   :label-width="formLabelWidth" >
        <Editor v-if="!loading.dialog"  :content="form.operator_context" />
      </el-form-item>
      <el-form class="devForm" :model="pDevForm" :rules="pDevRules" ref="pDevForm" v-if="(form.id && form.status_id > 1) || form.id && form.status_id === 1 && isOwner ">
     <div style="display: flex;">
      <el-form-item label="是否确认为Bug" prop="isBug" :label-width="formLabelWidth">
        <el-select size="mini"    v-model="pDevForm.isBug"  placeholder="请选择" :disabled="!isDevDisabled">
          <el-option   v-for="item in options"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
        </el-select>
      </el-form-item>
       <el-form-item label="修复BUG工时" prop="devWorkHour" :label-width="formLabelWidth">
         <el-input style="width: 92%;" type="number" v-model="pDevForm.devWorkHour" @change="handleDevEdit" placeholder="小时" :disabled="!isDevDisabled">时</el-input>
         <el-tooltip class="item" effect="light" placement="top">
           <div slot="content">
             <span>一天6工时，最多30工时</span>
           </div>
           <i class="el-icon-question" style="color: #409EFF;"></i>
         </el-tooltip>
       </el-form-item>
       <el-form-item class="testFormitem" label="验证BUG工时" prop="testWorkHour" :label-width="formLabelWidth" v-if="(form.id && form.status_id > 2) || form.id && form.status_id === 2 && isCreator ">
         <el-input style="width: 92%;" type="number" v-model="pDevForm.testWorkHour" @change="handleTestEdit" placeholder="小时" :disabled="!isTestDisabled">时</el-input>
         <el-tooltip class="item" effect="light" placement="top">
           <div slot="content">
             <span>一天6工时，最多30工时</span>
           </div>
           <i class="el-icon-question" style="color: #409EFF;"></i>
         </el-tooltip>
       </el-form-item>
     </div>
      <el-form-item label="处理内容"  prop="operatorContext" :label-width="formLabelWidth" >
        <Editor   :content="pDevForm.operatorContext" @contentData="changeDevContent"
                  :dialogVisibleModelType="form.id ? 'update' : 'create'" />
      </el-form-item>
        <el-form-item v-if="form.id && historylist.length" label="任务历史" :label-width="formLabelWidth">
          <TaskHistory :list="historylist" />
        </el-form-item>
      </el-form>
      <el-form :model="form" v-if="form.id">
        <el-form-item class="comment_warp" label="评论" :model="form" :label-width="formLabelWidth">
          <Comment  :id="form.id" :busiId="form.id"  type="5" />
        </el-form-item>
      </el-form>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-show="form.id && step != 2 && (isCreator || (form.owner.id === userId &&  (form.status_id === 0 || form.status_id === 1 )))" type="warning" @click="changeStep(2)">编 辑</el-button>
      <el-button v-show="!form.id" type="warning" :loading="loading.submit" @click="onSubmit" style="width:130px">创建</el-button>
      <el-button v-show="form.id && step == 2 && (isCreator || (form.owner.id === userId &&  (form.status_id === 0 || form.status_id === 1 )))" type="warning" :loading="loading.submit" @click="onSubmit">保存</el-button>
      <el-button v-show="form.id && isOwner && form.status_id === 0" type="warning" :loading="loading.submit" @click="SUbmitBugTask(1)">开始处理</el-button>
      <el-button v-show="form.id && isOwner && form.status_id === 1" type="warning" :loading="loading.submit" @click="DevSUbmitBugTask(2)">提交处理</el-button>
      <el-button v-show="form.id && isCreator && form.status_id === 2" type="warning" :loading="loading.submit" @click="SUbmitBugTask(3)">验收通过</el-button>
      <el-button v-show="form.id && isCreator && form.status_id === 2" type="warning" :loading="loading.submit" @click="SUbmitBugTask(4)">验收驳回</el-button>
     <el-button type="success" @click="handleClose">关 闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { Editor } from "@/components/index.js";
import Comment from '@/views/tops/devOps/producerSpace/components/project/comment.vue'
import Share from './share.vue'
import { formatEnToUtf8, formatTimeToDate } from "@/views/tops/devOps/components/util.js";
import {
  postDevOpsSpaceCreateOtherTaskApi,
  getDevOpsSpaceOtherDetailApi,
  postDevOpsSpaceCreateBugTaskApi,
  postDevOpsSpaceTestTaskApi,
  getDevOpsSpaceBugDetailApi,
  postDevOpsSpaceUpdateBugTaskApi,
  getDevOpsSpaceBugRelTestTaskApi,
  getDevOpsSpaceBugRelTaskApi,
  postDevOpsSpaceNewSUbmitBugApi,
  getDevOpsSpaceTestTaskApi,
  getDevOpsSpaceTaskDetailApi, getDevOpsSpaceFindOneDemandApi, getDevOpsSpaceHistoryTaskListApi
} from "@/server/tops/devOps";
import { mapState } from "vuex";
import {TaskHistory} from "@/views/tops/devOps/components/list";
export default {
  components: {TaskHistory, Editor, Share, Comment },
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    showDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    test_task_id: {
      default: '',
    },
    dev_task_id: {
      default: '',
    },
  },
  data() {
    return {
      options: [{
        value: 0,
        label: '否'
      },
        {
          value: 1,
          label: '是'
        }],
      form: {
        type:null,
        ownerId:null,
        priority: 'P1',
        plt: '',
        is_admin: false,
        plet: '',
        title: '',
        context:'',
        task_type:'',
        leading:'',
        related_task_id:'',
        related_task:[],
        related_test_task: [],
        related_test_task_id: '',
        severity:'',
        testTaskId: '',
        devTaskId: '',
        creatorId: '',
        owner:{},
      },
      leading:'',
      module:'',
      pDevRules: {
        isBug: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        operatorContext: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        devWorkHour: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      rules: {
        title: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        context: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        testTaskId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        devTaskId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        /*severity: {
          required: true,
          message: "必填",
          trigger: "blur",
        },*/
        type: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        priority: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        ownerId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        planFinishDate: {
          // required: true,
          message: "必填",
          trigger: "blur",
        },
        creatorId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '135px',
      loading: {
        dialog: false,
        submit: false,
        submitReviewed: false,
        submitRollBack:false
      },
      dialogVisibleTask: false,
      step: 1,
      formTaskInfo: {},
      showDetails: false,
      // 判断是否是产品
      isUserPm:false,
      tasks:[],
      alltask:{},
      reltestList: [],
      pDevForm:{
        isBug: 1,
        operatorContext: '',
        devWorkHour:'',
        testWorkHour:'',
      },
      userId: '',
      username: '',
      historylist: [],
    };
  },
  async mounted() {
    const { id = '', status = '', task_type = '' , context = this.setDefaultsContent() , demander = '' , leading = '' , plet = '' , plt = this.getDate() , priority = '' , project_system = '' , create_time= '' ,username : creator, title =''} = this.formInfo;
    const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    this.form = { ...this.form, id, status, task_type, context, demander, leading, plet, plt, priority,  project_system, create_time, creator ,title}
    this.$set(this.form, 'username', username)
    this.username = username;
    console.log("context",context)
    if (this.isUpdata) {
      await this.init(id);
      await this.getHistoryList();
    } else {
      this.step = 2;
      this.$set(this.form, 'user_pm', username)
      //查询测试任务详情
      if(this.test_task_id){
        await this.queryDevOpsSpaceTestTaskDetail(this.test_task_id);
      }
      //查询开发任务详情
      if(this.dev_task_id){
        await this.queryDevOpsSpaceTaskDetail(this.dev_task_id);
      }
      if(this.allUserList.DEVUSERUSER[username]){
        let defauleUserId = this.allUserList.DEVUSERUSER[username];
        this.form.creatorId = defauleUserId.toString();
      }
    }
    if(this.allUserList.ALLUSERIDLIST1[username]){
      this.userId = this.allUserList.ALLUSERIDLIST1[username];
    }
    //await this.GetTestTaskApi();
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
          allStatusList: (state) => state.devOps.ALLSTATUSLIST,
          BUGTYPE: (state) => state.devOps.BUGTYPE,
        }
    ),
    newTitle() {
      if (this.isUpdata) {
        return '缺陷-' + this.form.title;
      } else {
        return '新增缺陷'
      }
    },
    // 判断是否是新建
    isUpdata() {
      return this.form.id;
    },
    isCreator(){
      if(this.isAdmin || this.isCreatorLeader) return true;
      if(this.form.creator){
        return this.form.creator.nameEn === this.form.username;
      }
      return false;
    },
    isOwner(){
      if(this.isAdmin || this.isOwnerLeader) return true;
      if(this.form.owner){
        return this.form.owner.nameEn === this.form.username;
      }
      return false;
    },
    isAdmin(){
      if(this.username){
        if(this.allUserList.ALLUSERTYPE13 && this.allUserList.ALLUSERTYPE13[this.username]) return true
      }
      return false;
    },
    isCreatorLeader(){
      if(this.userId && this.form.creator){
        const creatorId = this.form.creator.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[creatorId]){
          return this.allUserList.LEADERUSER[creatorId] === this.userId;
        }
      }
      return false;
    },
    isOwnerLeader(){
      if(this.userId && this.form.owner){
        const ownerId = this.form.owner.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[ownerId]){
          return this.allUserList.LEADERUSER[ownerId] === this.userId;
        }
      }
      return false;
    },
    isDevDisabled(){
      return this.isOwner && this.form.status_id === 1;
    },
    isTestDisabled(){
      return this.isCreator && this.form.status_id === 2;
    },
    // 部分不可编辑
    isProjectDisabled() {
      if (this.isUpdata) { // 如果是更新页面
        if (this.step === 1) return true;
      }
      return false; // 默认可编辑
    },
    // 部分不可编辑
    isProjectDisabledEdit() {
      if (this.isUpdata) { // 如果是更新页面
        if (this.step === 2) return false;
      }
      return true; // 默认可编辑
    },
  },
  methods: {
    changeCreatorId(){
        this.reltestList=[]
      this.tasks=[]
      this.form.testTaskId=''
      this.form.devTaskId=''
      this.form.module=''
    },
    //提交处理
    DevSUbmitBugTask(type){
      this.$refs["pDevForm"].validate(async (valid) => {
        if (valid) {
          this.SUbmitBugTask(type)
        }
      })
    },
    SUbmitBugTask(type){
      let params = {type:type,id:this.form.id};
      if(type == 2){
        params = {...params,...this.pDevForm,devWorkHour:this.pDevForm.devWorkHour?this.pDevForm.devWorkHour.toString():'0'}
      }
      if(type == 3){
        if(!this.pDevForm.testWorkHour && this.pDevForm.testWorkHour !==0){
          this.$message({
            message: '测试工时必填',
            type: 'error'
          });
          return false;
        }
        params = {...params,testWorkHour:this.pDevForm.testWorkHour?this.pDevForm.testWorkHour.toString():'0'}
      }
      postDevOpsSpaceNewSUbmitBugApi(params).then((res)=>{
        if(res.status === 'success'){
          this.$notify({
            message: res.message || "保存成功",
            type: "success",
          })
          setTimeout(() => {
            this.handleClose();
          }, 500)
        }else{
          this.$notify({
            message: res.message || "数据错误",
            type: "error",
          })
        }
      });
    },
    async getHistoryList(){
      await getDevOpsSpaceHistoryTaskListApi({type:5,busiId: this.form.id}).then((res)=>{
        this.historylist = res.data;
      });
    },
    RelTestTaskList(type){
      getDevOpsSpaceBugRelTestTaskApi({type:type,creatorId:this.form.creatorId||null}).then((res)=>{
        let arr = {};
        res.data.forEach((item) => {
          let newstr= '【'+item.id+'】'+item.taskName;
          arr[item['id']] = newstr
        });
       this.reltestList = arr;
      })
    },
    BugRelTaskList(testTaskId){
      getDevOpsSpaceBugRelTaskApi({testTaskId: Number(testTaskId)}).then((res)=>{
        let arr = {};
        let allarr = {};
        res.data.forEach((item) => {
          let newstr= '【'+item.id+'】'+item.taskName;
          arr[item['id']] = newstr;
          allarr[item['id']] = item ;
        });
        this.tasks = arr;
        this.alltask = allarr;
      });
    },
    getDate() {
      var now = new Date().getTime();
      return now;
    },
    setDefaultsContent() {
      const str="<p><strong>【现象】</strong></p><br>" +
          "<p><strong>【预期结果】</strong></p><br>" +
          "<p><strong>【再现率】</strong></p><br>" +
          "<p><strong>【操作步骤】</strong></p>" +
          "<p>  1.</p>" +
          "<p>  2.</p>" +
          "<p>  3.</p><br>"+
          "<p><strong>【再现环境】</strong></p>"+
          "<p>  Device:</p>"+
          "<p>  Version:</p>"
      return str;
    },
    async GetTestTaskApi(){
      const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
      const params = {};
      params.page_num = 1
      params.page_size = 9999999
      params.tester_user = username ? username : ''
      params.task_issue_status = this.task_issue_status;
      const ret = await postDevOpsSpaceTestTaskApi(params);
      let arr = {};
      let allarr = {};
      ret.data.forEach((item) => {
        let newstr= '【'+item.d_id+'】'+item.t_title;
        arr[item['d_id']] = newstr
        allarr[item['d_id']] = item ;
      });
      this.tasks = arr;
      this.alltask = allarr;


    },
    changeTestTask(val){
      this.BugRelTaskList(val);
    },
    changeTask(val){
      this.form.related_task_id = val;
      let module = this.alltask[val].module;
      this.form.module = module;
    },
    focusHandle(){
      this.RelTestTaskList(this.form.type);
    },
    changeType(val){
      this.reltestList = [];
      this.tasks = [];
      this.form.devTaskId = '';
      this.form.testTaskId = '';
      this.alltask = [];
      this.form.module = '';
      this.RelTestTaskList(val);
    },
    changeStep() {
      this.step = 2;
    },
    //预估工时只能正整数
    handleDevEdit(event) {
      // 使用正则表达式限制输入内容
      const regex = /^(?:[0-9]|[1-2][0-9]|30)(?:\.[0-9])?$/;
      const inputValue = event;
      const match = regex.test(inputValue);
      if (match) {
        if(inputValue>30){
          this.pDevForm.devWorkHour=0.0
          this.$notify({
            message:  "请输入0到30的能带一位小数!",
            type: "warning",
          });
        }else{
          this.pDevForm.devWorkHour = Number(inputValue)
        }
      } else {
        this.pDevForm.devWorkHour=0.0
        this.$notify({
          message:  "请输入0到30的能带一位小数!",
          type: "warning",
        });
      }
    },
    //预估工时只能正整数
    handleTestEdit(event) {
      // 使用正则表达式限制输入内容
      const regex = /^(?:[0-9]|[1-2][0-9]|30)(?:\.[0-9])?$/;
      const inputValue = event;
      const match = regex.test(inputValue);
      if (match) {
        if(inputValue>30){
          this.pDevForm.testWorkHour=0.0
          this.$notify({
            message:  "请输入0到30的能带一位小数!",
            type: "warning",
          });
        }else{
          this.pDevForm.testWorkHour = Number(inputValue)
        }
      } else {
        this.pDevForm.testWorkHour=0.0
        this.$notify({
          message:  "请输入0到30的能带一位小数!",
          type: "warning",
        });
      }
    },
    // 获取需求详情
    async init(id) {
      this.loading.dialog = true
      try {
        const ret = await getDevOpsSpaceBugDetailApi({ id });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          ...info,
          type: info.type.toString(),
          ownerId:info.owner_id.toString(),
          testTaskId:info.testTaskId.toString(),
          devTaskId: info.devTaskId.toString(),
          creatorId: info.creator.id ? info.creator.id.toString(): '',
        };
        // console.log('ownerId',info.owner_id.toString())
        this.pDevForm.isBug = this.form.is_bug;
        this.pDevForm.operatorContext = this.form.operatorContext;
        this.pDevForm.devWorkHour = this.form.dev_work_hour;
        this.pDevForm.testWorkHour = this.form.test_work_hour;
        if(this.form.status_id == 1){
          this.pDevForm.devWorkHour = '';
        }
        if(this.form.status_id == 2){
          this.pDevForm.testWorkHour = '';
        }
        //查询测试任务详情
        if(info.testTaskId){
         this.queryDevOpsSpaceTestTaskDetail(info.testTaskId);
        }
        //查询开发任务详情
        if(info.devTaskId){
         this.queryDevOpsSpaceTaskDetail(info.devTaskId);
        }

      } catch (error) {
        this.$notify({
          message: error || "数据错误",
          type: "error",
        })
      } finally {
        this.loading.dialog = false
      }

    },
    // 提交
    async onSubmit(close = true) {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.moduleSubmit(close)
        }
      });
    },
    // 调用提交接口
    async moduleSubmit(close = true){
      const username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
      this.form.creator = username;
      try {
        close && this.$set(this.loading, 'submit', true)
        const {
          title = "",
          context = "",
          priority = "",
          type = "",
          ownerId = '',
          planFinishDate = '',
          testTaskId = '',
          devTaskId = '',
          module = '',
          creatorId = '',
        } = this.form;
        const param = { title, context, priority, type:Number(type), ownerId:Number(ownerId),  planFinishDate, testTaskId:Number(testTaskId), devTaskId:Number(devTaskId),module, creatorId: Number(creatorId)};
        // id 存在 更新 不存在 创建
        const ret = this.isUpdata ? await postDevOpsSpaceUpdateBugTaskApi({ ...param, id: this.form.id || "" }) : await postDevOpsSpaceCreateBugTaskApi(param);
        if (ret.status === 'success') {
          if (close) {
            this.$notify({
              message: '提交成功',
              type: "success",
            })
            setTimeout(() => {
                this.handleClose();
            }, 500)
          }
        } else {
          this.$notify({
            message: ret.message || "失败",
            type: "error",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || "网络错误",
          type: "error",
        })
      } finally {
        this.loading.submit = false;
      }
    },
    // 获取测试任务详情
    async queryDevOpsSpaceTestTaskDetail(taskId) {
      this.loading.dialog = true;
      try {
        const ret = await getDevOpsSpaceTestTaskApi({
          taskId: taskId || ""
        });
        let info = ret.data[0] || {};
        this.form.testTaskId = info.id.toString();
          this.form.type=info.demand_type.toString()
       
        let arr = {};
        ret.data.forEach((item) => {
          let newstr = '【'+item.id+'】'+item.name;
          arr[item['id']] = newstr
        });
        this.reltestList = arr;
        // if(info.test_status === 4){
        //    this.form.type = '1';
        // }else if(info.test_status === 5){
        //   this.form.type = '2';
        // }else{
        //   await this.queryDemandDetail(info.demand_id);
        // }
      } catch (error) {
        this.$notify({
          message: error || "获取测试任务失败",
          type: "error",
        })
      } finally {
        this.loading.dialog = false;
      }
    },
    //获取需求
    async queryDemandDetail(demandId){
      const ret = await getDevOpsSpaceFindOneDemandApi({id:demandId});
      const info = ret.data[0] || {};
      if(info.status === 8){
        this.form.type = '3';
      }else if(info.status === 11){
        this.form.type = '4';
      }else{
        this.form.type = '4';
      }


    },
    // 获取开发任务详情
    async queryDevOpsSpaceTaskDetail(taskId) {
      this.loading.dialog = true;
      try {
        const ret = await getDevOpsSpaceTaskDetailApi({
          taskId: taskId || "",
        });
        console.log('ret', ret);
        let info = ret.data[0] || {};
        this.form.devTaskId = info.id.toString();
        this.form.module = info.module || '';
        // this.form.ownerId=(info?.developsId).toString()
        if (!this.form.ownerId) {
        this.form.ownerId = info?.developsId ? info.developsId.toString() : '';
        }
        let arr = {};
        let allarr = {};
        ret.data.forEach((item) => {
          let newstr= '【'+item.id+'】'+item.name;
          arr[item['id']] = newstr;
          allarr[item['id']] = item ;
        });
        this.tasks = arr;
        this.alltask = allarr;
      } catch (error) {
        this.$notify({
          message: error || "获取开发任务失败",
          type: "error",
        })
      } finally {
        this.loading.dialog = false;
      }
    },
    checkTestTaskStatusType(status){
      //test_status
      if(status === 0){
      }
    },
    // 关闭弹窗
    handleClose(step) {
      this.hideDialogVisible(step)
    },
    // 修改富文本内容
    changeContent(val) {
      this.form.context = val;
    },
    changeDevContent(val) {
      this.pDevForm.operatorContext = val;
    },
    // 将多个英文名转换为中文
    formatEnToUtf8,
    formatTimeToDate,
  }
};
</script>
<style lang="scss">
.bug_model_dialog {
  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .table_text_click {
    text-decoration: underline;
    color: #409EFF;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .table_text_no_click {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .el-dialog__body {
    padding-bottom: 0;
  }
  .el-form-item__content {
    line-height: 16px;
  }
}

.popperDom {
  max-width: 240px;
}
.devForm{
  .el-input__inner{
    height: 28px;
    line-height: 28px;
  }
  .el-form-item__label {
     line-height: 16px;
  }
}
.testFormitem .el-form-item__label:before {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}
</style>
